import { WebRtcTestHandler } from '../WebRtcTestHandler'

export class VideoTest{
    private readonly offerOptions = {
        offerToReceiveAudio: true,
        offerToReceiveVideo: true
    }
    private readonly mediaConstraints = { audio: true, video: true }
    private readonly errorMessages = {
        REMOTE_STREAM_EMPTY: 'Der empfangene Video Stream ist leer.',
        COULD_NOT_READ_LOCAL_STREAM: 'Die Kamera konnte nicht gelesen werden. Bitte stellen Sie sicher, dass Sie der Nutzung Ihrer Kamera zugestimmt haben.'
    }

    private localStream: MediaStream | undefined
    private remoteStream: MediaStream | undefined

    private rtcPeerConn1: RTCPeerConnection | undefined
    private rtcPeerConn2: RTCPeerConnection | undefined


    public readonly name = 'VideoTest'

  constructor(
    private readonly rtcConfiguration: RTCConfiguration,
    public readonly testMethod: (candidate: RTCIceCandidate) => boolean,
    private readonly handler: WebRtcTestHandler, 
    private readonly remoteVideoElement: HTMLVideoElement)
    { }

    public endTest(successful: boolean, errorMessage?: string) {
        if(errorMessage) {
            this.handler.displayVideoError(errorMessage)
        }

        if (this.rtcPeerConn1) this.rtcPeerConn1.close()
        if (this.rtcPeerConn2) this.rtcPeerConn2.close()

        this.remoteVideoElement.srcObject = null

        this.localStream?.getTracks().forEach(track => track.stop())
        this.remoteStream?.getTracks().forEach(track => track.stop())
    }

    public async startTest() {
        try {
            this.rtcPeerConn1 = new RTCPeerConnection(this.rtcConfiguration)

            this.rtcPeerConn2 = new RTCPeerConnection(this.rtcConfiguration)

        } catch {
            this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_CREATE_PEER_CONNECTION)
            return
        }

        this.rtcPeerConn1.onicecandidate = async (evt) => {
            let iceCandidate = evt.candidate
            if (!iceCandidate) return
            if(this.testMethod(iceCandidate))
            {            
                this.rtcPeerConn2?.addIceCandidate(iceCandidate)
            }
        }

        this.rtcPeerConn2.onicecandidate = (evt) => {
            let iceCandidate = evt.candidate
            if (!iceCandidate) return
            if(this.testMethod(iceCandidate))
            {            
                this.rtcPeerConn1?.addIceCandidate(iceCandidate)
            }
        }

        this.rtcPeerConn2.ontrack = (evt) => {
            if (evt.streams.length > 0) {
                this.remoteStream = evt.streams[0]
                this.remoteVideoElement.srcObject = this.remoteStream as MediaStream
            } else{
                this.endTest(false, this.errorMessages.REMOTE_STREAM_EMPTY)
                return
            }
        }

        try {
            this.localStream = await navigator.mediaDevices.getUserMedia(this.mediaConstraints)
            this.localStream.getTracks().forEach(track => this.rtcPeerConn1?.addTrack(track, this.localStream as MediaStream))
        } catch (err) {
            this.endTest(false, this.errorMessages.COULD_NOT_READ_LOCAL_STREAM)
            this.handler.showMediaRequestMessage()
            return
        }

        let offer: RTCSessionDescriptionInit

        try {
            offer = await this.rtcPeerConn1.createOffer(this.offerOptions)
        } catch (err) {
            this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_CREATE_OFFER)
            return
        }

        try {
            await this.rtcPeerConn1.setLocalDescription(offer)
            await this.rtcPeerConn2.setRemoteDescription(offer)
        } catch (err) {
            this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_SET_OFFER_DESCRIPTION)
            return
        }

        let answer: RTCSessionDescriptionInit
        try {
            answer = await this.rtcPeerConn2.createAnswer()
        } catch (err) {
            this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_CREATE_ANSWER)
            return
        }

        try {
            await this.rtcPeerConn1.setRemoteDescription(answer)
            await this.rtcPeerConn2.setLocalDescription(answer)
        } catch (err) {
            this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_SET_ANSWER_DESCRIPTION)
            return
        }
    }
}